export default "__VITE_ASSET__DjHZLpga__"